// ═══════════════════════════════════════════════════════════════════
//  modules/erp/ERP.js
//  ERP
// ═══════════════════════════════════════════════════════════════════

import { useEffect, useState } from "react";
import { API_BASE } from "../../socle/api";
import { THEME } from "../../socle/theme";
import { GlobalAuditPanel } from "./GlobalAuditPanel";
import { PlayerDetail } from "./PlayerDetail";

export function ERP({ token, user, cible, onNavigate }) {
  const [query, setQuery] = useState("");
  const [results, setResults] = useState([]);
  const [searching, setSearching] = useState(false);
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [showAudit, setShowAudit] = useState(false);
  // Lot 3 — arrivée depuis une page du wiki : on ouvre la fiche du joueur
  const [retourWiki, setRetourWiki] = useState(null);
  useEffect(() => {
    if (!cible || cible.type !== "joueur" || !cible.id) return;
    let vivant = true;
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/api/players/${cible.id}`, { headers: { Authorization: `Bearer ${token}` } });
        const d = await res.json();
        if (vivant && d && d.player) { setSelectedPlayer(d.player); setRetourWiki(cible.retour || null); }
      } catch { /* joueur introuvable : on reste sur la recherche */ }
    })();
    return () => { vivant = false; };
  }, [cible, token]);

  const search = async () => {
    if (query.length < 2) return;
    setSearching(true);
    try {
      const res = await fetch(`${API_BASE}/api/players/search?q=${encodeURIComponent(query)}`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      setResults(Array.isArray(data) ? data : []);
    } catch { setResults([]); }
    setSearching(false);
  };

  if (showAudit) return <GlobalAuditPanel token={token} onClose={() => setShowAudit(false)} />;
  if (selectedPlayer) return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      {retourWiki && (
        <button onClick={() => onNavigate && onNavigate("wiki", retourWiki)}
          style={{ alignSelf: "flex-start", background: THEME.purpleDim, border: `1px solid ${THEME.purple}`, color: THEME.purple, borderRadius: 8, padding: "6px 12px", cursor: "pointer", fontSize: 12.5, fontWeight: 600 }}>
          ← Retour à « {retourWiki.titre || "la page du wiki"} »
        </button>
      )}
      <PlayerDetail player={selectedPlayer} token={token} onNavigate={onNavigate}
        onBack={() => { setSelectedPlayer(null); setRetourWiki(null); }} user={user} />
    </div>
  );

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
        <h2 style={{ color: THEME.text, fontSize: 18, fontWeight: 700, margin: 0 }}>👤 Joueurs (ERP)</h2>
        <button onClick={() => setShowAudit(true)}
          style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, color: THEME.textMuted, borderRadius: 8, padding: "8px 14px", cursor: "pointer", fontSize: 13, fontWeight: 600 }}>📜 Journal d'audit</button>
      </div>

      <div style={{ display: "flex", gap: 10 }}>
        <input value={query} onChange={(e) => setQuery(e.target.value)} onKeyDown={(e) => e.key === "Enter" && search()}
          placeholder="Rechercher un joueur par pseudo..."
          style={{ flex: 1, background: THEME.surface, border: `1px solid ${THEME.border}`, borderRadius: 8, padding: "10px 16px", color: THEME.text, fontSize: 14, outline: "none" }} />
        <button onClick={search} disabled={searching || query.length < 2}
          style={{ background: THEME.accentDim, border: `1px solid ${THEME.accent}`, color: THEME.accent, borderRadius: 8, padding: "10px 20px", cursor: "pointer", fontSize: 14, fontWeight: 700, opacity: searching ? 0.6 : 1 }}>
          {searching ? "..." : "🔍 Chercher"}
        </button>
      </div>

      {results.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <div style={{ color: THEME.textMuted, fontSize: 12 }}>{results.length} joueur(s) trouvé(s)</div>
          {results.map((p) => (
            <div key={p.uuid} onClick={() => setSelectedPlayer(p)}
              style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 10, padding: "14px 18px", display: "flex", alignItems: "center", gap: 14, cursor: "pointer" }}
              onMouseEnter={(e) => (e.currentTarget.style.borderColor = THEME.accent)}
              onMouseLeave={(e) => (e.currentTarget.style.borderColor = THEME.border)}>
              <img src={`https://mc-heads.net/avatar/${p.uuid}/40`} alt={p.username}
                style={{ width: 40, height: 40, imageRendering: "pixelated", borderRadius: 4 }}
                onError={(e) => { e.target.style.display = "none"; }} />
              <div style={{ flex: 1 }}>
                <div style={{ color: THEME.text, fontWeight: 700, fontSize: 15 }}>{p.username}</div>
                <div style={{ color: THEME.textMuted, fontSize: 11, marginTop: 2 }}>
                  Grade : <span style={{ color: THEME.accent }}>{p.primary_group}</span>
                  {p.box_count > 0 && <span style={{ marginLeft: 10 }}>🏠 {p.box_count} box(es)</span>}
                </div>
              </div>
              <span style={{ color: THEME.textMuted, fontSize: 12 }}>Voir la fiche →</span>
            </div>
          ))}
        </div>
      )}

      {results.length === 0 && query.length >= 2 && !searching && (
        <div style={{ color: THEME.textMuted, fontSize: 13, textAlign: "center", padding: 40 }}>Aucun joueur trouvé pour "{query}"</div>
      )}

      {query.length === 0 && (
        <div style={{ color: THEME.textDim, fontSize: 13, textAlign: "center", padding: 40 }}>
          <div style={{ fontSize: 40, marginBottom: 8 }}>🔍</div>
          Tape au moins 2 caractères pour rechercher un joueur
        </div>
      )}
    </div>
  );
}
